import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

// Slim standalone top bar used by independent labs so every environment has a
// consistent "Back to HMG Labs" control without borrowing another lab's nav.
export default function LabChrome({ title, subtitle, accent = "hsl(var(--primary))", children, contentClassName = "" }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  return (
    <div className="h-screen flex flex-col bg-background text-foreground overflow-hidden">
      <header className="h-14 shrink-0 border-b border-border bg-card flex items-center gap-4 px-4 z-40">
        <button
          onClick={() => navigate("/labs")}
          data-testid="back-to-hmg-labs"
          className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Back to HMG Labs
        </button>
        <div className="h-6 w-px bg-border" />
        <div className="flex items-center gap-2 min-w-0">
          <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{ background: accent }} />
          <div className="truncate">
            <div className="text-sm font-semibold leading-none truncate">{title}</div>
            {subtitle && <div className="text-[11px] text-muted-foreground mt-0.5 truncate">{subtitle}</div>}
          </div>
        </div>
        <div className="ml-auto flex items-center gap-3">
          <span className="text-xs text-muted-foreground hidden sm:inline">{user?.name}</span>
          <Button variant="ghost" size="sm" className="gap-2 text-muted-foreground" data-testid="chrome-signout"
            onClick={() => { logout(); navigate("/login"); }}>
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Sign out</span>
          </Button>
        </div>
      </header>
      <main className={`flex-1 min-h-0 ${contentClassName}`}>{children}</main>
    </div>
  );
}
